import { useAppDispatch } from '@hooks/redux.hooks';
import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { useCallback } from 'react';

export const useWithDispatch = <T extends string, Payload>(fn: ActionCreatorWithPayload<Payload, T>) => {
  const dispatch = useAppDispatch();

  return useCallback((payload: Payload) => dispatch(fn(payload)), [dispatch, fn]);
};
